import { Injectable } from '@angular/core';

import { RouteTranslator } from './route-translator';

/**
 * Angular-facing holder for the active locale's route translations.
 *
 * internals — it monkey-patched `RouterConfigLoader.loadChildren` and
 * `NavigationTransitions.afterPreactivation` — and broke on Angular 21 when the route
 * recognizer moved from RxJS to async/await (the patched `loadChildren` returned an
 * Observable where the recognizer now `await`s a Promise, yielding `undefined` routes).
 *
 * All translation logic lives in the Angular-free {@link RouteTranslator}.
 */
@Injectable({ providedIn: 'root' })
export class RouteTranslatorService {
  private translator = new RouteTranslator(null);

  get isReady(): boolean {
    return this.translator.isReady;
  }

  setTranslations(translations: Record<string, any>): void {
    this.translator = new RouteTranslator(translations);
  }

  translateText(key: string): string {
    return this.translator.translateText(key);
  }

  translatePath(path: string): string {
    return this.translator.translatePath(path);
  }

  translateRoute(path: string | unknown[]): string | unknown[] {
    return this.translator.translateRoute(path);
  }

  stripTrailingSlash(url: string): string {
    return this.translator.stripTrailingSlash(url);
  }
}
